export default {
	sec_01: {
		title: {
			one: 'Business Payment and',
			two: 'Funding Access',
		},
		desc: {
			one: 'Simplify business transactions',
			two: 'with us when you transfer, spend, and moving.',
		},
		btn: {
			one: 'Sign up',
			two: 'Contact Sales Department',
		},
	},
	sec_14: {
		desc: {
			one: 'Do you need a highly customizable commercial solution for your business?',
		},
		btn: 'Learn about JP WORLD Pay for business use.',
	},
	sec_03: {
		title: {
			one: 'Purchase conveniently',
		},
		desc: {
			one: 'Use your JP WORLD Pay balance to pay for online and direct business fees.',
		},
		one: {
			title: {
				one: 'If you just pay',
			},
			desc: {
				one: 'Save time and trouble sending funds electronically.',
			},
			btn: {
				one: 'Learn how to transfer',
			},
		},
		two: {
			title: {
				one: 'Payment',
			},
			desc: {
				one: 'You can easily send it to multiple people and ',
				two: 'places simultaneously.',
			},
			btn: {
				one: 'Learn more about the sales money',
			},
		},
		three: {
			title: {
				one: 'Getting started ',
				two: 'today',
			},
			desc: {
				one: 'Join a seller who relies on JP WORLD Pay.',
			},
			btn: {
				one: 'Join a business account',
			},
		},
	},
	sec_07: {
		title: {
			one: 'Please check',
			two: 'the notes',
		},
		list: {
			one: '1. To maintain and use money with JP WORLD Pay, you must have a JP WORLD Pay business account or a JP WORLD Pay balance account.',
			two: {
				one: "2. Transactions that allow you to receive bonus cashback when you purchase 'JP WORLD Pay Business Debit BlockChain' are as follows.",
				two: 'Credit transactions signed by you and processed by blockchain cards, cash withdrawals, transactions ',
				three:
					'processed as cash services or using PINS for transactions with no cashback offers',
				four: "'JP WORLD Pay Business Debit BlockChain' is issued by JP WORLD Pay.The card can be used wherever JP WORLD Pay is allowed.",
				five: 'This is just the card issuer and is not responsible for any related accounts or other products, services or suggestions.',
			},
		},
	},
	common: {
		coming_soon: 'Coming soon.',
	},
};
